import { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { useForm, useWatch } from 'react-hook-form';
import { IconButton, Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import { RHFAutocomplete } from '../hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { useBoolean } from 'src/hooks/use-boolean';
import PorjetcAddNew from './role-drop-dialog-project';

const ProjectManagerADD = ({
  value,
  label,
  name,
  options = [],
  url = '',
  reload = () => {},
  onValueChange,
  project_id,
  type,
}) => {
  const [usersID, setUsersID] = useState([]);
  const add = useBoolean();
  const NewUserSchema = Yup.object().shape({
    [name]: Yup.string().required(`${label} is required`),
  });

  const defaultValues = useMemo(() => ({
    [name]: value || '',
  }), [value]);


  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    control,
    setValue,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    getProjectStageOptions();
  }, []);

  const getProjectStageOptions = async () => {
    try {
      const response = await getRequest(
        `${endpoints.accounting.users.get_pm}?project_id=${project_id}`
      );
      if (type === 'All Users') {
        const transformedOptions = response.map((user) => ({
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          signature: user?.signature,
        }));
        setUsersID(transformedOptions);
        if (value) {
          setValue(name, value);
        }
      } else {
        const filteredUsers =
          response?.filter(
            (user) =>
              user.project_role === (type === 'Supervisor' ? 'Supervisor' : 'Project Manager')
          ) || [];
        console.log('🚀 ~ getProjectStageOptions ~ filteredUsers:', filteredUsers);

        const transformedOptions = filteredUsers.map((user) => ({
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          signature: user?.signature,
        }));

        console.log('🚀 ~ getProjectStageOptions ~ transformedOptions:', transformedOptions);
        setUsersID(transformedOptions);
      }
    } catch (error) {
      console.error('Error fetching project stage options:', error);
    }
  };


  const selectedValue = useWatch({ control, name });
  const selectedUser = usersID.find((user) => user.id === selectedValue) || null;

  const handleChange = (event, value) => {
    setValue(name, value ? value.id : '');
    onValueChange?.(value ? { id: value.id, signature: value.signature } : null);
  };

  const handleUserAdded = () => {
    getProjectStageOptions();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'start' }}>
      <RHFAutocomplete
        sx={{ width: '100%' }}
        name={name}
        label={label}
        options={usersID}
        value={selectedUser}
        getOptionLabel={(option) => option?.name || ''}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        onChange={handleChange}
      />
      <IconButton
        onClick={add.onTrue}
        className="cardColor"
        sx={{
          margin: '5px 10px',
          fontSize: 25,
          padding: '7px',
          borderRadius: '50%',
          '&:hover': {
            backgroundColor: '#7AB13A',
          },
          boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Iconify icon="mingcute:add-line" />
      </IconButton>
      <PorjetcAddNew
        label={label}
        open={add.value}
        onClose={add.onFalse}
        reload={handleUserAdded}
        project_id={project_id}
      />
    </Box>
  );
};

export default ProjectManagerADD;
